export default __webpack_public_path__ + "static/media/msg.f32ae05e.svg";